import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const mobileDevicePurchaseRoutes: RouteObject[] = [
  {
    path: '/mobile-device-purchase',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Mobile Device Purchases',
      crumb: () => ({ label: 'Mobile Device Purchases', to: '/mobile-device-purchase' }),
    },
  },
  {
    path: '/mobile-device-purchase/view/:id',
    element: lazyElement(() => import('./View')),
    handle: { crumb: () => ({ label: 'Purchase' }) },
  },
];

export default mobileDevicePurchaseRoutes;
